import React from 'react';
import { isEmpty } from 'lodash';

// Local Dependencies
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';
import { GLOBAL_LABELS } from 'constants/common';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { widgetNoData as WidgetNoData } from 'ui/views/widgets/widgetNoData';
 *
 * // render
 * <WidgetNoData propName='propValue'/>
 */
export const widgetNoData = ( props ) => {
    return (
        <div className='ui-widget-no-data'>

            {/* icon */}
            <div className='ui-widget-no-data__icon'>
                <Icon name='warningBlue' width={ 50 } height={ 50 } />
            </div>

            {/* title */}
            <p className='ui-widget-no-data__title'>
                {
                    isEmpty( props.message ) ? (
                        getLabel( GLOBAL_LABELS.DISPLAY_TEXT_NO_DATA_FOUND )
                    ) : (
                        getLabel( props.message )
                    )
                }
            </p>
        </div>
    );
};

// set display name
widgetNoData.displayName = 'widgetNoData';

// set default props
widgetNoData.defaultProps = {
    message: null,
};

// prop types
widgetNoData.propTypes = {};
